
import React from 'react';
import SEO from '@/components/SEO';

interface DashboardHeaderProps {
  userName: string | null;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ userName }) => {
  return (
    <>
      <SEO 
        title="Client Dashboard - IT Management Solutions"
        description="Access your IT Management Solutions client portal and services."
        canonicalUrl="https://itmgmtsol.com/dashboard"
      />
    </>
  );
};

export default DashboardHeader;
